import { Controller } from 'stimulus'
import datepicker from 'js-datepicker'

// A calendar for a YYYY-MM-DD date field. Set up (and torn down) with the
// field, so it also works on fields a reflex adds.
//
//   = f.input :expires_at, input_html: { data: { controller: "datepicker", "datepicker-range-value": "future" } }
//
// Ranges: "future" (from tomorrow, e.g. access link expiry) or "release"
// (30 years ago to 2 years ahead)
export default class extends Controller {
  static values = { range: String }

  connect() {
    this.picker = datepicker(this.element, {
      ...this.limits(),
      formatter: (input, date) => { input.value = formatDate(date) }
    })
  }

  disconnect() {
    this.picker?.remove()
  }

  limits() {
    const now = new Date()
    if (this.rangeValue === 'future') {
      return { minDate: new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1) }
    }
    return {
      minDate: new Date(now.getFullYear() - 30, now.getMonth(), now.getDate()),
      maxDate: new Date(now.getFullYear() + 2, now.getMonth(), now.getDate())
    }
  }
}

function formatDate(date) {
  const month = `${date.getMonth() + 1}`.padStart(2, '0')
  const day = `${date.getDate()}`.padStart(2, '0')
  return `${date.getFullYear()}-${month}-${day}`
}
